// @ts-nocheck
import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import { SafeDictionary } from "@insite/client-framework/Common/Types";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import constants from "@store/constants"; // Store Custom Code

export function canAddToCart(
    state: ApplicationState,
    product: ProductModel,
    productInfo?: ProductInfo,
    configurationCompleted?: boolean,
    variantSelectionCompleted?: boolean,
    configurationSelection?: SafeDictionary<string>,
) {
    if (
        !product ||
        (!configurationCompleted &&
            product.detail?.configuration &&
            !product.detail?.configuration.isKit &&
            product.detail?.configuration.configSections &&
            product.detail?.configuration.configSections.length > 0)
    ) {
        return false;
    }

    // Fixed configuration, if any section has CantBuy is true, we return false.
    if (
        product.detail?.configuration &&
        product.detail?.configuration.isKit &&
        product.detail?.configuration.configSections &&
        product.detail?.configuration.configSections.length > 0
    ) {
        for (const configSection of product.detail!.configuration.configSections) {
            if (configSection.sectionOptions?.some(x => x.cantBuy)) {
                return false;
            }
        }
    }

    // Standard configuration, check CantBuy property of selected options.
    if (
        configurationCompleted &&
        product.detail?.configuration &&
        !product.detail?.configuration.isKit &&
        product.detail?.configuration.configSections &&
        product.detail?.configuration.configSections.length > 0 &&
        configurationSelection &&
        Object.values(configurationSelection).length > 0
    ) {
        const sectionOptions = Object.values(configurationSelection).filter(sectionOptionId => !!sectionOptionId);
        if (sectionOptions) {
            for (const configSection of product.detail!.configuration.configSections) {
                const selectedOptions = configSection.sectionOptions?.filter(x => sectionOptions.indexOf(x.id) > -1);
                if (selectedOptions && selectedOptions.every(x => x.cantBuy)) {
                    return false;
                }
            }
            return true;
        }
    }

    /* Store Custom Code - Start */
    if (
        productInfo?.pricing?.additionalResults?.errorCode === constants.errorCode.invalidCustomerNumber ||
        productInfo?.pricing?.additionalResults?.errorCode === constants.errorCode.invalidBillToAddress
    ) {
        return false;
    }
    /* Store Custom Code - End */

    const { canAddToCart, allowBackOrder } = getSettingsCollection(state).productSettings;
    const availability =
        productInfo?.inventory?.inventoryAvailabilityDtos?.find(
            o => o.unitOfMeasure.toLowerCase() === (productInfo?.unitOfMeasure?.toLowerCase() || ""),
        )?.availability || undefined;

    return (
        canAddToCart &&
        !product.cantBuy &&
        (product.canAddToCart ||
            ((configurationCompleted || variantSelectionCompleted) &&
                (allowBackOrder || (availability && availability.messageType !== 2)) &&
                !product.canConfigure))
    );
}
